module.exports = __webpack_public_path__ + "static/media/Bronn.7f461f1e.jpg";